import _slicedToArray from "C:/Users/itsvn/Documents/GitHub/hellovunguyen-gatsby/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import { useState, useEffect } from "react";

var useLocalStorageState = function useLocalStorageState(key, defaultValue) {
  var _useState = useState(function () {
    var storedValue = typeof window !== 'undefined' && window.localStorage ? window.localStorage.getItem(key) : null;
    return storedValue === null ? defaultValue : JSON.parse(storedValue);
  }),
      _useState2 = _slicedToArray(_useState, 2),
      value = _useState2[0],
      setValue = _useState2[1];

  useEffect(function () {
    var listener = function listener(e) {
      if (e.storageArea === localStorage && e.key === key) {
        setValue(JSON.parse(e.newValue));
      }
    };

    window.addEventListener("storage", listener);
    return function () {
      window.removeEventListener("storage", listener);
    };
  }, [key]);

  var setLocalStorageValue = function setLocalStorageValue(newValue) {
    setValue(function (currentValue) {
      var result = typeof newValue === "function" ? newValue(currentValue) : newValue;
      localStorage.setItem(key, JSON.stringify(result));
      return result;
    });
  };

  return [value, setLocalStorageValue];
};

export default useLocalStorageState;